import { withStyles } from "$components/mui-styles";
import { Box, Typography } from "@material-ui/core";

const GreyTextTypography = withStyles((theme) => ({
  root: {
    color: theme.palette.grey[700],
  },
}))(Typography);

export const CellWithSubscript = ({
  script,
  subscript,
}: {
  script: string;
  subscript: string;
}) => {
  return (
    <Box sx={{ flexDirection: "column" }}>
      <Typography variant="body2">{script}</Typography>
      <Box sx={{ flexDirection: "row", alignContent: "center" }}>
        <GreyTextTypography variant="subtitle2">{subscript}</GreyTextTypography>
      </Box>
    </Box>
  );
};
